import { EProviderType } from './promosPage';

export enum EPageBlock {
  NewPromo = 'new_promo',
  BankPromo = 'bank_promo',
  Beneficial = 'beneficial',
  PromoEnding = 'promo_ending',
  Categories = 'categories',
  LowMortgageRates = 'low_mortgage_rates',
}

export type TCategories = 'top_categories' | 'bottom_categories';

export interface INewPromoBlockPageExtra {
  block: EPageBlock.NewPromo;
  newbuilding_id: number;
  promo_id: number;
  position: number;
  provider_type: EProviderType;
}

export interface IBankPromoBlockPageExtra {
  block: EPageBlock.BankPromo;
  bank_id: number;
  position: number;
}

export interface ILastChanceDiscountBlockPageExtra {
  block: EPageBlock.PromoEnding;
}

export interface ITopPromosPageBlockExtra {
  block: EPageBlock.Beneficial;
  results?: ITopPromosResults[];
}

export interface ITopPromosResults {
  type: EProviderType;
  id: number;
}

export interface ICategoriesBlockPageExtra {
  block: EPageBlock.Categories;
}
